import { render } from "./chghost.vue?vue&type=template&id=043797b3&ts=true"
import script from "./chghost.vue?vue&type=script&lang=ts"
export * from "./chghost.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__